document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver(() => {
      const pdps = document.querySelectorAll('spark-pdp');
      const cards = document.querySelectorAll('spark-product-card');
    
      // ----------- spark-pdp: Añadir al carrito -----------
      pdps.forEach((pdp, i) => {
        const shadow = pdp.shadowRoot;
        if (!shadow) {
          console.warn(`⚠️ spark-pdp #${i} no tiene shadowRoot`);
          return;
        }
  
        const spans = shadow.querySelectorAll('.button-purchase .purchase-amount');
        spans.forEach((span, j) => {
          const text = span.textContent.trim();
  
          if (text.startsWith('Agregar')) {
            span.textContent = 'Añadir al carrito';
          }
        });
      });
  
      // ----------- spark-product-card: Añadir -----------
      cards.forEach((card, i) => {
        const shadow = card.shadowRoot;
        if (!shadow) {
          return;
        }
  
        const spans = shadow.querySelectorAll('.button-purchase .purchase-amount');
        spans.forEach((span, j) => {
          const text = span.textContent.trim();
  
          if (text.startsWith('Agregar')) {
            span.textContent = 'Añadir';
          }
        });
      });

      // ----------- spark-drawer: Traducción de texto de direcciones guardadas -----------
      traducirTextoDrawer();
      // Fallback: intentar traducir varias veces durante 2 segundos por si el contenido aparece tarde
      let intentos = 0;
      const maxIntentos = 10;
      const intervalo = setInterval(() => {
        traducirTextoDrawer();
        intentos++;
        if (intentos >= maxIntentos) clearInterval(intervalo);
      }, 200);
    });
  
    observer.observe(document.body, { childList: true, subtree: true });
  });
  
  function traducirTextoDrawer() {
    const drawers = document.querySelectorAll('spark-drawer');
    drawers.forEach((drawer) => {
      const shadow = drawer.shadowRoot;
      if (!shadow) return;
      // Traducción de direcciones guardadas
      const ps = shadow.querySelectorAll('p.mx-auto.my-0.text-wrap.text-base.text-default-body');
      ps.forEach((p) => {
        if (p.textContent.trim() === "Your saved addresses will appear here once you've added one.") {
          p.textContent = "Tus direcciones guardadas aparecerán aquí una vez que hayas agregado una.";
        }
      });
      // Traducción de "Pay by Invoice"
      const payByInvoicePs = shadow.querySelectorAll('label[for^="payment-method-"] p');
      payByInvoicePs.forEach((p) => {
        if (p.textContent.trim() === "Pay by Invoice") {
          p.textContent = "Pago contraentrega";
        }
      });
    });
  }
  